import { useState } from 'react';
import i18next from 'i18next';
import reduce from 'lodash/reduce';

import languages from './languages';

const useLanguages = defaultLanguage => {
  const locallySaved = window.localStorage.getItem('inplayer_language');

  const isValidLanguage = lang => languages.hasOwnProperty(lang);

  const [currentLanguage, setCurrentLanguage] = useState(
    locallySaved || (isValidLanguage(defaultLanguage) ? defaultLanguage : 'en')
  );

  const setLanguage = newLanguage => {
    if (isValidLanguage(newLanguage)) {
      if (newLanguage !== currentLanguage) {
        setCurrentLanguage(newLanguage);
      }

      return newLanguage;
    }

    return 'en';
  };

  const translate = (key, interpolations) => (
    i18next.t(key, { lng: currentLanguage, ...interpolations })
  );

  if (i18next && !i18next.isInitialized) {
    i18next.init({
      interpolation: {
        escapeValue: false,
      },
      lng: currentLanguage,
      resources: reduce(languages, (collection, value, key) => ({
        ...collection,
        [key]: {
          translation: { ...value },
        }
      }), {}),
    });
  }

  return {
    language: currentLanguage,
    setLanguage,
    translate,
  };
};

export default useLanguages;